import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, IconButton, TextField, Typography } from '@material-ui/core';
import { searchComponentStyles } from '../../css/style';
import withStyles from '@material-ui/core/styles/withStyles';

const initialState = {
  term: '',
};

const styles = searchComponentStyles();

class SearchComponent extends Component {
  constructor(props) {
    super(props);
    this.getSearchTerm();
  }

  getSearchTerm = () => {
    const { resourceName } = this.props;
    const searchTerm = sessionStorage.getItem('searchTerm');
    const sameResource = resourceName === sessionStorage.getItem('resourceName');
    if (!searchTerm || !sameResource) {
      sessionStorage.removeItem('searchTerm');
      this.state = initialState;
    } else {
      this.state = { term: searchTerm };
    }
  }

  handleTextChange = (e, fieldValue) => {
    const { updateParentState } = this.props;
    const { value } = e.target;

    this.setState({
      [fieldValue]: value,
      errorText: '',
    });

    if (updateParentState) updateParentState(value);
  };

  onClickSearch = () => {
    const { onHandleSearch, value, resourceName } = this.props;
    const { term } = this.state;
    if (resourceName === 'orders') {
      onHandleSearch(value);
      return;
    }
    sessionStorage.setItem('searchTerm', term);
    sessionStorage.setItem('resourceName', resourceName);
    onHandleSearch(term);
  };

  onClickClearSearch = () => {
    const { onHandleClearSearch } = this.props;
    if (onHandleClearSearch) {
      onHandleClearSearch();
    }
    this.setState(initialState);
  };

  disableButton = () => {
    const { term } = this.state;
    return !term;
  };

  checkEnterPressed = (e) => {
    if (e.keyCode === 13) {
      this.onClickSearch();
    }
  };

  reconcileTextValue = () => {
    const { value, resourceName } = this.props;
    const { term } = this.state;
    return resourceName === 'orders' ? value : term;
  }

  getContainerStyle = () => {
    const { resourceName } = this.props;
    return resourceName === 'orders' ? styles.widerSearchContainer : styles.searchContainer;
  }

  textFieldInputProps = () => {
    const { classes } = this.props;
    return {
      disableUnderline: true,
      classes: { root: classes.inputStyle },
    };
  }

  render() {
    const { placeholder } = this.props;
    return (
      <div style={this.getContainerStyle()}>
        <IconButton
          style={styles.searchButton}
          onClick={this.onClickSearch}
          disabled={this.disableButton()}
        >
          <Icon style={styles.searchIcon}>search</Icon>
        </IconButton>
        <TextField
          autoFocus
          style={styles.textFieldStyle}
          placeholder={placeholder || 'Search'}
          InputProps={this.textFieldInputProps()}
          type="term"
          value={this.reconcileTextValue()}
          onChange={e => this.handleTextChange(e, 'term')}
          onKeyDown={e => this.checkEnterPressed(e)}
        />
        <div style={styles.clearLinkContainer}>
          <Typography
            style={styles.clearSearchLink}
            onClick={this.onClickClearSearch}
          >
            Clear
          </Typography>
        </div>
      </div>
    );
  }
}

SearchComponent.propTypes = {
  onHandleSearch: PropTypes.func,
  onHandleClearSearch: PropTypes.func,
};

SearchComponent.defaultProps = {
  onHandleSearch: null,
  onHandleClearSearch: null,
};

export default withStyles(searchComponentStyles)(SearchComponent);
